<div class="confirm-dialog-overlay" [class.is-open]="open" [attr.aria-hidden]="!open" (click)="onClose()">
  <div
    class="confirm-dialog"
    [class.is-open]="open"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    (click)="$event.stopPropagation()"
  >
    <div class="confirm-dialog-header" [id]="titleId">{{ title }}</div>
    <div class="confirm-dialog-body">{{ message }}</div>
    <div class="confirm-dialog-actions">
      <button
        type="button"
        class="btn"
        [ngClass]="confirmVariant === 'danger' ? 'btn-danger' : 'btn-primary'"
        (click)="onConfirm()"
      >
        {{ confirmText }}
      </button>
      <button type="button" class="btn btn-default" (click)="onClose()">{{ cancelText }}</button>
    </div>
  </div>
</div>
